module.exports = __webpack_public_path__ + "russierenouvelables/img/vk.dd455372.webp";